// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"16":"error-component","40":"search-component","120":"product-component","590":"artist-component","695":"lang-en","786":"privacy-component","923":"imprint-component"}[chunkId] + "." + {"16":"ac20999d","40":"5c40d5c3","120":"7b9ccb6b","590":"38479441","695":"d60b649b","786":"4ededc93","923":"13a6ee97"}[chunkId] + ".js";
};